import { Sparkles } from "lucide-react";

import type { MapLeadAnalysis } from "../../api/mapLeadService";
import { usePersona } from "@/shared/brand/persona";

/** 军师商机分析卡(抽屉与「我的线索」回看共用一份渲染 —— 单一出处,别各画各的)。 */
export function AnalysisCard({ analysis }: { analysis: MapLeadAnalysis }) {
  const persona = usePersona();
  return (
    <div className="space-y-2 rounded-md border border-primary/25 bg-primary/5 p-3 text-xs">
      <p className="flex items-center gap-1 text-2xs font-semibold uppercase tracking-wide text-primary">
        <Sparkles className="h-3 w-3" aria-hidden />
        {persona.title}商机分析
      </p>
      <p className="leading-relaxed">{analysis.summary}</p>
      <dl className="grid grid-cols-[56px_1fr] gap-x-2 gap-y-1">
        {analysis.recommendedProduct && (
          <>
            <dt className="text-muted-foreground">推荐产品</dt>
            <dd>{analysis.recommendedProduct}</dd>
          </>
        )}
        {analysis.entryPoint && (
          <>
            <dt className="text-muted-foreground">切入点</dt>
            <dd>{analysis.entryPoint}</dd>
          </>
        )}
        {analysis.opening && (
          <>
            <dt className="text-muted-foreground">首句话术</dt>
            <dd>“{analysis.opening}”</dd>
          </>
        )}
        {analysis.nextAction && (
          <>
            <dt className="text-muted-foreground">下一步</dt>
            <dd>{analysis.nextAction}</dd>
          </>
        )}
      </dl>
      {analysis.reasons.length > 0 && (
        <ul className="space-y-0.5 border-t border-primary/15 pt-1.5 text-2xs text-muted-foreground">
          {analysis.reasons.slice(0, 4).map((r) => (
            <li key={r}>· {r}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
